const KEY_HEX = process.env.NEXT_PUBLIC_ENCRYPTION_KEY!;

async function getKey(): Promise<CryptoKey> {
  const keyBytes = hexToBytes(KEY_HEX);
  return crypto.subtle.importKey(
    "raw",
    keyBytes.buffer as ArrayBuffer, // ✅ fix
    { name: "AES-GCM" },
    false,
    ["encrypt", "decrypt"],
  );
}

function hexToBytes(hex: string): Uint8Array<ArrayBuffer> {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.slice(i, i + 2), 16);
  }
  return bytes as Uint8Array<ArrayBuffer>; // ✅ fix
}

function toBase64(buffer: ArrayBuffer | Uint8Array<ArrayBuffer>): string {
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  return btoa(String.fromCharCode(...bytes));
}

function fromBase64(b64: string): Uint8Array<ArrayBuffer> {
  return Uint8Array.from(atob(b64), (c) =>
    c.charCodeAt(0),
  ) as Uint8Array<ArrayBuffer>; // ✅ fix
}

export async function encryptPayload(data: unknown): Promise<string> {
  const key = await getKey();
  const iv = crypto.getRandomValues(
    new Uint8Array(12),
  ) as Uint8Array<ArrayBuffer>; // ✅ fix
  const encoded = new TextEncoder().encode(JSON.stringify(data));

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoded.buffer as ArrayBuffer, // ✅ fix
  );

  const encryptedBytes = new Uint8Array(encrypted);
  const ciphertext = encryptedBytes.slice(0, -16) as Uint8Array<ArrayBuffer>;
  const tag = encryptedBytes.slice(-16) as Uint8Array<ArrayBuffer>;

  return [toBase64(iv), toBase64(tag), toBase64(ciphertext)].join(":");
}

export async function decryptPayload<T>(payload: string): Promise<T> {
  const key = await getKey();
  const [ivB64, tagB64, ciphertextB64] = payload.split(":");

  const iv = fromBase64(ivB64);
  const tag = fromBase64(tagB64);
  const ciphertext = fromBase64(ciphertextB64);

  const combined = new Uint8Array(
    ciphertext.length + tag.length,
  ) as Uint8Array<ArrayBuffer>;
  combined.set(ciphertext);
  combined.set(tag, ciphertext.length);

  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    combined.buffer as ArrayBuffer, // ✅ fix
  );

  return JSON.parse(new TextDecoder().decode(decrypted)) as T;
}
